import type { PocDatepickerValueType, PocDateType } from 'commons/types';
import { isInvertedRange } from 'core/utils/dates';
import { useState } from 'react';
import { fromRangeValue, toRangeValue } from '../date-picker.mapper';

type PickedRange = { from?: PocDateType; to?: PocDateType };

interface UseDateRangeFilterParams {
    appliedFrom?: PocDateType;
    appliedTo?: PocDateType;
    onApplyRange: (from?: PocDateType, to?: PocDateType) => void;
}

export const useDateRangeFilter = ({ appliedFrom, appliedTo, onApplyRange }: UseDateRangeFilterParams) => {
    const [draft, setDraft] = useState<PickedRange>({ from: appliedFrom, to: appliedTo });
    const [synced, setSynced] = useState<PickedRange>({ from: appliedFrom, to: appliedTo });

    if (appliedFrom !== synced.from || appliedTo !== synced.to) {
        setSynced({ from: appliedFrom, to: appliedTo });
        setDraft({ from: appliedFrom, to: appliedTo });
    }

    const isDraftInverted = isInvertedRange(draft.from, draft.to);

    const handleChange = (_field: string, value: PocDatepickerValueType) => setDraft(fromRangeValue(value));

    const handleApply = () => {
        if (isDraftInverted) {
            return;
        }
        onApplyRange(draft.from, draft.to);
    };

    const handleClear = () => {
        setDraft({});
        onApplyRange(undefined, undefined);
    };

    return {
        value: toRangeValue(draft.from, draft.to),
        secondaryValue: toRangeValue(appliedFrom, appliedTo),
        isApplyDisabled: isDraftInverted,
        handleChange,
        handleApply,
        handleClear,
    };
};
